import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button';
import React, { useEffect, useState } from 'react';
import { playSound, SoundTypes } from '@/utils/sound';
import { useMountedState } from 'react-use';
import { useSafeState } from '../../api/hooks';

type Props = Partial<
  {
    sound?: SoundTypes;
    onClick?: ButtonProps['onClick'] | ((event: React.MouseEvent<HTMLElement>) => Promise<void>);
  } & Omit<ButtonProps, 'type'> & {
      type: ButtonProps['type'] | 'secondary';
    }
>;

const PosButton: React.ForwardRefExoticComponent<React.RefAttributes<HTMLButtonElement> &
  Props> = React.forwardRef(
  (
    {
      sound = 'click',
      onClick = () => {},
      onFocus,
      type,
      loading: loadingProp,
      ...buttonProps
    }: Props,
    ref
  ) => {
    const [loading, setLoading] = useSafeState(loadingProp);
    let isSecondary = false;
    if (type === 'secondary') {
      type = 'default';
      isSecondary = true;
    }

    useEffect(() => {
      setLoading(loadingProp);
    }, [loadingProp]);

    return (
      <Button
        className={isSecondary ? 'ant-btn-secondary' : ''}
        loading={loading}
        {...buttonProps}
        type={type}
        ref={ref}
        onClick={async (...args) => {
          playSound(sound);
          const promise = onClick(...args);
          if (promise && promise.then) {
            setLoading(true);
            promise.finally(() => {
              setLoading(false);
            });
          }
        }}
        onFocus={e => {
          if (onFocus) {
            onFocus(e);
          } else {
            e.target.blur();
          }
        }}
      />
    );
  }
);

export default PosButton;
